/** Search feature constants for US-5.6 Search and Filter */

/** Filter dimension slugs from the server-side filter registry */
export const DIMENSION_SLUGS = {
  STATUS_ATTRIBUTE: "status-attribute",
  ENTITY_TYPE: "entity-type",
  DATE_RANGE: "date-range",
  SORT: "sort",
  SEARCH_MODE: "search-mode",
} as const;

/** Available search modes */
export const SEARCH_MODES = {
  SMART: "smart",
  EXACT: "exact",
  FUZZY: "fuzzy",
} as const;

/** Date filter slugs (hyphenated, matching DB filter_allowed_values) */
export const DATE_FILTERS = {
  ALL_TIME: "all-time",
  TODAY: "today",
  THIS_WEEK: "this-week",
  THIS_MONTH: "this-month",
} as const;

/** Sort field slugs */
export const SORT_BY = {
  UPDATED_AT: "updated-at",
  CREATED_AT: "created-at",
  NAME: "name",
  RELEVANCE: "relevance",
} as const;

/** Sort options for the dropdown (label + value + order) */
export const SORT_OPTIONS = [
  { label: "Last Used", value: SORT_BY.UPDATED_AT, order: "desc" },
  { label: "Newest First", value: SORT_BY.CREATED_AT, order: "desc" },
  { label: "Oldest First", value: SORT_BY.CREATED_AT, order: "asc" },
  { label: "A → Z", value: SORT_BY.NAME, order: "asc" },
  { label: "Z → A", value: SORT_BY.NAME, order: "desc" },
] as const;

/** Sort order values */
export const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
} as const;

/** Page size options for the results-per-page dropdown */
export const PAGE_SIZE_OPTIONS = [20, 50, 100] as const;

/** Default values for search parameters */
export const SEARCH_DEFAULTS = {
  DEBOUNCE_MS: 300,
  PAGE: 1,
  LIMIT: 20 as number,
} as const;

/** API endpoint paths for search */
export const SEARCH_API_PATHS = {
  SEARCH: "/v1/search",
  FILTERS: "/v1/search/filters",
} as const;

/** Maps UI sort slug to API parameter value */
export const SORT_BY_TO_API: Readonly<Record<string, string>> = {
  [SORT_BY.UPDATED_AT]: "updated_at",
  [SORT_BY.CREATED_AT]: "created_at",
  [SORT_BY.NAME]: "name",
  [SORT_BY.RELEVANCE]: "relevance",
} as const;
